import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import LoadingWrapper from "../../../common/loading-wrapper";
import { Table } from "antd";
import { getTopParties } from "../../../../services/api-ptab";
import { sorterNumberGen, sorterStringGen } from "../../../../helpers/table";
import { toItemPTABSearchLink } from "../../../../helpers/converters";
import { withTableConfig } from "../../../common/table-config-hoc";

const TopParties = ({ type, query, k = 20, style = {} }) => {
  const [state, setState] = useState({
    data: null,
    loading: true,
    error: false
  });

  const _getParties = () => {
    getTopParties({ type: type }, query, k)
      .then(json => {
        setState({
          data: json.map((r, i) => ({
            ...r,
            rank: i + 1
          })),
          loading: false
        });
      })
      .catch(() => {
        setState({
          loading: false,
          error: true
        });
      });
  };

  useEffect(() => {
    _getParties();
  }, [type, query, k])

  const nameTitle = type === "p" ? "Petitioner" : "Patent Owner";
  const columns = [
    {
      dataIndex: "name",
      title: nameTitle,
      sorter: sorterStringGen("name"),
      render: l => [l, toItemPTABSearchLink(l, null, type === "p" ? "petitioners" : "patent_owners")]
    },
    {
      dataIndex: "count",
      title: "#Cases",
      sorter: sorterNumberGen("count")
    },
    {
      dataIndex: "rank",
      title: "Rank"
    }
  ];

  const WrappedTable = withTableConfig(Table, { dataSource: state.data });

  return (
    <LoadingWrapper loading={state.loading} error={state.error} style={style}>
      <WrappedTable dataSource={state.data} title={`Top ${k} ${nameTitle}s`} columns={columns} rowKey={"name"} pagination={false} size="small" />
    </LoadingWrapper>
  );
}

TopParties.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  type: PropTypes.string,
  query: PropTypes.object,
  k: PropTypes.number
};

export default withRouter(TopParties);
